const props = {
  MuiButton: {},
  MuiBadge: {
    color: 'error',
  },
}

export default props
